// extracted by mini-css-extract-plugin
export default {"statusDisplay":"Account_statusDisplay__6p8EN"};